import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';

// No step indicator on purpose: the signup should not look long.
export const SignupShell: React.FC<{ title: string; subtitle: string; children: React.ReactNode }> = ({
    title, subtitle, children,
}) => (
    <div className="min-h-screen bg-gradient-to-br from-[#E8F7F7] via-blue-50 to-indigo-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full overflow-hidden">
            <div className="px-6 sm:px-8 pt-8 text-center">
                <img
                    src="/assets/logo_reveca_def.png"
                    alt="Reveca"
                    className="h-9 w-auto mx-auto mb-4"
                />
                <h1 className="text-2xl font-bold text-gray-900 mb-1">{title}</h1>
                <p className="text-gray-500 text-sm">{subtitle}</p>
            </div>
            <div className="px-6 sm:px-8 py-8">{children}</div>
        </div>
    </div>
);

export const InlineError: React.FC<{ message: string | null }> = ({ message }) =>
    message ? (
        <div className="p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2 text-red-600 text-sm">
            <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
            <p>{message}</p>
        </div>
    ) : null;

export const LogoutLink: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    return (
        <p className="text-center text-sm text-gray-500 mt-6">
            <button
                type="button"
                disabled={disabled}
                onClick={async () => {
                    await logout();
                    navigate('/login', { replace: true });
                }}
                className="text-gray-500 hover:text-gray-700 underline disabled:opacity-50"
            >
                Cerrar sesión
            </button>
        </p>
    );
};
